import { forwardRef } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { t } from '@transifex/native';

interface Props extends ButtonProps {
	text: string;
	analyticsId?: string;
}

export const XMCSButton = forwardRef<HTMLButtonElement, Props>(
	({ analyticsId, text, ...rest }, ref) => (
		<Button
			ref={ref}
			size="sm"
			minW="unset"
			data-behavior-analytics-id={analyticsId && `btn-${analyticsId}`}
			{...rest}
			data-testid={`btn-${text}`}
		>
			{t(text)}
		</Button>
	),
);
XMCSButton.displayName = 'XMCSButton';
